<mat-form-field
  class="multiselect-search-dropdown-container"
  [ngClass]="{useCustomToggler: useCustomToggler}"
  [appearance]="useCustomToggler ? 'fill' : 'outline'"
  [class.mb-1]="!useCustomToggler ? control?.invalid && control?.touched : false"
>
  <div class="select-trigger-container d-flex ai-center" *ngIf="useCustomToggler">
    <span
      class="icon icon-filter"
      [class.active]="value.length"
      (click)="isOverlayOpened = true"
      data-test-id="multiselect-search-dropdown-toggler"
    ></span>
    <span
      *ngIf="value.length > 0"
      (click)="removeAllSelectedItems($event)"
      class="remove-selected-items"
      data-test-id="remove-selected-items"
      class="filtered row ai-center remove-all-button"
      [attr.data-test-id]="[testId, 'remove_all_items'].join('_')"
    >
      <span class="fs-xs item">{{ value.length }}</span>
      <span class="icon icon-close"></span>
    </span>
  </div>

  <mat-label class="mb-1 color-navi fs-sm medium" *ngIf="!useCustomToggler && label">
    <span>{{ label }}</span>
    <span *ngIf="isRequired" class="color-error">*</span>:
  </mat-label>

  <ng-container *ngIf="!useCustomToggler">
    <button
      class="rst-button"
      *ngIf="control?.value != null && ItemsSelect.triggerValue"
      [class.rst-button--disabled]="control?.disabled"
      (click.stop-propagation)="reset()"
      mat-icon-button
      type="button"
      aria-label="Clear element"
      [attr.data-test-id]="['clear_button', testId].join('_')"
      [disabled]="control?.disabled"
    >
      <mat-icon [inline]="true">close</mat-icon>
    </button>
  </ng-container>

  <mat-select
    [formControl]="control"
    (openedChange)="openedChange($event)"
    panelClass="multiselect-search-dropdown-panel"
    [multiple]="true"
    #matSelect="matSelect"
    [attr.data-test-id]="[testId, 'select'].join('_')"
    [disableOptionCentering]="disableOptionCentering"
    [disableRipple]="true"
    [class.has-value]="control?.value != null && ItemsSelect?.triggerValue"
    #ItemsSelect
  >
    <mat-option class="multiselect-search-dropdown-input">
      <ngx-mat-select-search
        [searching]="false"
        [formControl]="filterControl"
        placeholderLabel="Search"
        [showToggleAllCheckbox]="useSelectAll"
        [toggleAllCheckboxChecked]="value.length > 0 && value.length === (selectionListCombined$ | async)?.length"
        [toggleAllCheckboxTooltipMessage]="'common.label.select-all' | translate"
        (toggleAll)="toggleSelectAll($event)"
        [placeholderLabel]="'common.label.search' | translate"
      ></ngx-mat-select-search>
    </mat-option>

    <ng-container
      *ngIf="{
        selectedItemListLoading: selectedItemListLoading$ | async,
        searchedItemList: searchedItemList$ | async,
        selectedItemList: selectedItemList$ | async
      } as values"
    >
      <mat-option *ngFor="let item of values.selectedItemList; trackBy: trackByItem" [value]="item.value">
        <div [innerHTML]="item.label"></div>
      </mat-option>

      <div class="searching d-flex jc-center" *ngIf="values.selectedItemListLoading !== false">
        <div class="d-flex ai-center" data-test-id="multiselect-search-dropdown-loading">
          <span class="spinner spinner-bounce-middle mr-1"></span>
          <span class="regular pl-h">{{ 'common.statuses.loading' | translate }}</span>
        </div>
      </div>

      <ng-container *ngIf="values.searchedItemList?.showNotFound && values.selectedItemListLoading === false">
        <div class="not-found d-flex jc-center" data-test-id="multiselect-search-dropdown-not-found">Not found</div>
      </ng-container>

      <ng-container *ngIf="values.searchedItemList !== null">
        <ng-container *ngIf="!values.searchedItemList?.showNotFound && values.selectedItemListLoading === false">
          <mat-option
            *ngFor="let item of values.searchedItemList; let first = first; trackBy: trackByItem"
            [value]="item.value"
            [class.search-list-first-item]="first && values.selectedItemList.length"
          >
            <div [innerHTML]="item.label"></div>
          </mat-option>
        </ng-container>
      </ng-container>
    </ng-container>
  </mat-select>
  <ng-container *ngIf="!useCustomToggler">
    <mat-hint *ngIf="inputHint" class="hint">
      <span *ngIf="inputHintIcon" class="icon icon-info"></span> {{inputHint
    }}</mat-hint>

    <mat-error *ngIf="control?.invalid && control?.touched && !ItemsSelect.panelOpen">
      <span class="icon icon-error fs-md"></span> {{getErrorMessage()}}</mat-error>
  </ng-container>
</mat-form-field>
